import styled from "styled-components";
//import ParticleBackground from './ParticleBackground';

export const HeroContainer = styled.div`

    background-color: #434343;
    background-position: center;
    background-size: cover;
    min-height: 80vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;   
    text-align: center;
    @media only screen and (max-width: 600px){
        justify-content: flex-start;
        min-height: 45vh;
        align-items: initial;
        display: flex;
    }
  
`;

export const HeroH1 = styled.h1`
padding-top: 12px;
font-size: clamp(1rem, 10vw, 5rem);
font-family: 'Source Code Pro', monospace;
word-wrap: break-word;
color: #4AF626;
margin-bottom: 1rem;
letter-spacing: 3px;
@media only screen and (max-width: 600px){
    padding-top: 0px;
}


`;
export const HeroH2 = styled.h2`
font-size: clamp(1rem, 10vw, 3rem);
font-family: 'Source Code Pro', monospace;
color: #4AF626;
margin-bottom: 1rem;
letter-spacing: 2px;
`;

export const HeroH3 = styled.h3`
font-size: clamp(1rem, 10vw, 2rem);
font-family: 'Source Code Pro', monospace;
color: #4AF626;
margin-bottom: 1rem;
letter-spacing: 2px;
@media only screen and (max-width: 600px){
    font-size: 24px;
}
`;
